import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const BreakEmaLine = ({
  priceToBreak,
  candleDuration,
  periodLength,
  size,
  scaleY,
  portalRef,
}) => {
  const json = {
    Category: 'Setup',
    Type: 'Break EMA',
    'Break Price': ApplyRounding(Number(priceToBreak), 2),
    'Candle Duration': candleDuration,
    'Period Length': periodLength
  };

  return (
    <>
      {scaleY ? (
        <>
          <line
            stroke={colors.blue}
            strokeWidth={2}
            x1={0}
            x2={size}
            y1={scaleY(Number(priceToBreak))}
            y2={scaleY(Number(priceToBreak))}
          ></line>
          <HoverBox
            json={json}
            topBoundary={scaleY(Number(priceToBreak)) - 2}
            bottomBoundary={scaleY(Number(priceToBreak)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
          />
        </>
      ) : null}
    </>
  );
};

BreakEmaLine.propTypes = {
  candleDuration: PropTypes.any,
  periodLength: PropTypes.any,
  priceToBreak: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.any,
  portalRef: PropTypes.object,
};
